// extracted by mini-css-extract-plugin
module.exports = {"phone":"phone_phone_Jb0bx","day":"phone_day_26Nyt","time":"phone_time_3-0Ls","body":"phone_body_1TmtU","push":"phone_push_3vGLs","top":"phone_top_3Wv0A","code":"phone_code_75zki"};